import { Box, Button, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import {
  CaymanCountryLogoWithText,
  LogoContainerResponsive,
} from '@/components/Icon/Logo';
import { FullPageLoaderOverlay } from '@/components/Layout/FullPageLoader';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';
import {
  ContentContainer,
  ResponsiveMarginTopMessage,
} from '@/components/Layout/Page/Page.styled';

import { useICBChecking } from '@/hooks/useICBChecking';
import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

export function CaymanCountryICBCheckingPage() {
  const { isLoading, onGoBanking } = useICBChecking();
  const { t } = useTranslate();

  if (isLoading) {
    return (
      <FullPageLoaderOverlay
        bgColor={(theme: Theme) => theme.palette.background.paper}
      />
    );
  }

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: (
          <CaymanCountryLogoWithText
            alt="Cayman Country Logo with Text"
            {...getDataTestId('cayman-icb-checking-logo-with-text')}
          />
        ),
      }}
    >
      <ContentContainer>
        <LogoContainerResponsive>
          <CaymanCountryLogoWithText
            alt="Cayman Country Logo with Text"
            {...getDataTestId('cayman-icb-checking-logo-with-text')}
          />
        </LogoContainerResponsive>
        <ResponsiveMarginTopMessage
          {...getDataTestId('cayman-icb-checking-page-title')}
        >
          {t('createNewAccount.icbChecking.header')}
        </ResponsiveMarginTopMessage>
        <Typography variant="bodyB2Regular">
          <Trans
            i18nKey="createNewAccount.icbChecking.body"
            components={{ b: <b /> }}
          />
        </Typography>
      </ContentContainer>
      <Box width="100%">
        <Form>
          <Button
            onClick={onGoBanking}
            {...getDataTestId('cayman-icb-checking-login-button')}
          >
            {t('createNewAccount.icbChecking.button.goToBanking')}
          </Button>
        </Form>
      </Box>
    </Page>
  );
}
